import { Tooltip, Typography } from "antd";
import "./company-list.scss";

const { Text } = Typography;

export interface CompanyItem {
  companyId?: string;
  companyHistoryId?: string;
  projectParticipantId?: string;
  shortName?: string | null;
  fullName?: string | null;
  inn?: string | null;
  kpp?: string | null;
  phone?: string | null;
  email?: string | null;
}

const CompanyTooltipContent = ({ company }: { company: CompanyItem }) => (
  <div className="company-list__tooltip">
    {company.inn && (
      <div className="company-list__tooltip-row">
        <span className="company-list__tooltip-label">ИНН:</span>
        <span className="company-list__tooltip-value">{company.inn}</span>
      </div>
    )}
    {company.kpp && (
      <div className="company-list__tooltip-row">
        <span className="company-list__tooltip-label">КПП:</span>
        <span className="company-list__tooltip-value">{company.kpp}</span>
      </div>
    )}
    {company.phone && (
      <div className="company-list__tooltip-row">
        <span className="company-list__tooltip-label">Телефон:</span>
        <span className="company-list__tooltip-value">{company.phone}</span>
      </div>
    )}
    {company.email && (
      <div className="company-list__tooltip-row">
        <span className="company-list__tooltip-label">Email:</span>
        <span className="company-list__tooltip-value">{company.email}</span>
      </div>
    )}
  </div>
);

interface CompanyListProps {
  companies?: CompanyItem[] | null;
  separator?: "newline" | "comma";
}

export const CompanyList = ({
  companies,
  separator = "newline",
}: CompanyListProps) => {
  if (!companies || companies.length === 0) {
    return <Text type="secondary">—</Text>;
  }

  if (separator === "comma") {
    return (
      <span className="company-list company-list--inline">
        {companies.map((company, index) => (
          <span key={company.companyId ?? index}>
            <Tooltip
              title={<CompanyTooltipContent company={company} />}
              placement="topLeft"
              overlayStyle={{ maxWidth: 280 }}
            >
              <span className="company-list__item">
                {company.shortName || company.fullName || "—"}
              </span>
            </Tooltip>
            {index < companies.length - 1 && (
              <span className="company-list__separator">, </span>
            )}
          </span>
        ))}
      </span>
    );
  }

  return (
    <div className="company-list">
      {companies.map((company, index) => (
        <Tooltip
          key={company.companyId ?? index}
          title={<CompanyTooltipContent company={company} />}
          placement="topLeft"
          overlayStyle={{ maxWidth: 280 }}
        >
          <span className="company-list__item">
            {company.shortName || company.fullName || "—"}
          </span>
        </Tooltip>
      ))}
    </div>
  );
};
